import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import Navbar from "../layout/Navbar";
import News from "../layout/News";
import Footer from "../layout/Footer";
import MoreBtn01 from "../assets/images/more-btn-01.png";
import MoreBtn01Hover from "../assets/images/more-btn-01-h.png";
import MoreBtn02 from "../assets/images/more-btn-02.png";
import MoreBtn02Hover from "../assets/images/more-btn-02-h.png";
import MoreBtn03 from "../assets/images/more-btn-03.png";
import MoreBtn03Hover from "../assets/images/more-btn-03-h.png";
import MoreBtn04 from "../assets/images/more-btn-04.png";
import MoreBtn04Hover from "../assets/images/more-btn-04-h.png";
import MoreBtn05 from "../assets/images/more-btn-05.png";
import MoreBtn05Hover from "../assets/images/more-btn-05-h.png";
import { SliderView } from "../section/home";
import { useCallback, useEffect, useRef, useState } from "react";

const learnMore = [
  {
    link: "/focusActivities",
    image: MoreBtn01,
    imageHover: MoreBtn01Hover,
  },
  {
    link: "/socialActivity",
    image: MoreBtn02,
    imageHover: MoreBtn02Hover,
  },
  {
    link: "/reward",
    image: MoreBtn03,
    imageHover: MoreBtn03Hover,
  },
  {
    link: "/branchList",
    image: MoreBtn04,
    imageHover: MoreBtn04Hover,
  },
  {
    link: "/eliteRecruitment",
    image: MoreBtn05,
    imageHover: MoreBtn05Hover,
  },
];

function Home() {
  const isMounted = useRef(false);

  const [homeSlider, setHomeSlider] = useState([]);

  const fetchSliderData = useCallback(async () => {
    const resJson = await fetch("/api/homepage/slider");
    const res = await resJson.json();
    const { data } = res;

    setHomeSlider(data);
  }, []);

  const onInit = useCallback(async () => {
    await fetchSliderData();
  }, [fetchSliderData]);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      onInit();
    }
  }, [onInit]);

  return (
    <>
      <Navbar />
      <header className="bg-cover bg-banner">
        <div className="pt-36 pb-40 mobile:pt-9 mobile:pb-14 pl-20 table:pl-0 mobile:pl-0 table:max-w-[1000px] table:mx-auto table:w-[90%] mobile:w-[90%] mobile:max-w-[500px] mobile:mx-auto">
          <div className="relative aspect-[1060/600] w-[1060px] table:w-full mobile:w-full">
            <div className="home-slider relative z-10 left-[1%] top-[1.25%] w-[98%]">
              <SliderView list={homeSlider} />
            </div>
            <div className="absolute w-full h-full z-0 top-0 left-0 bg-white rounded-3xl" />
          </div>
        </div>
        {/* <Slider /> */}
      </header>
      <main>
        <section className="py-16 bg-cover bg-no-repeat bg-center bg-news">
          <div className="max-w-[1200px] mx-auto w-[85%] text-center table:max-w-[800px] mobile:w-[75%] mobile:max-w-[400px]">
            <div className="mx-auto max-w-[350px] mb-6 mobile:max-w-[260px]">
              <img src="/asset/image/index/news-title.png" alt="" />
            </div>
            <News />
          </div>
        </section>
        <section className="bg-more bg-center bg-cover flex flex-col items-center relative px-20 pb-32 pt-20 gap-20 mobile:h-auto mobile:p-10 mobile:gap-10">
          <div className="absolute w-full top-0 left-0 h-full z-0 pointer-events-none mobile:hidden">
            <div className="absolute top-4 left-3 -scale-x-100 w-[350px] aspect-[154/123] bg-moreDecoT bg-cover bg-no-repeat bg-center" />
            <div className="absolute bottom-4 left-3 -scale-x-100 w-[350px] aspect-[1078/809] bg-moreDecoB bg-cover bg-no-repeat bg-center" />
            <div className="absolute top-4 right-3 w-[350px] aspect-[154/123] bg-moreDecoT bg-cover bg-no-repeat bg-center" />
            <div className="absolute bottom-4 right-3 w-[350px] aspect-[1078/809] bg-moreDecoB bg-cover bg-no-repeat bg-center" />
          </div>
          <div className="w-[350px] aspect-[1305/412] bg-moreTitle bg-cover bg-no-repeat bg-center mobile:w-full mobile:max-w-[300px]" />
          <ul className="relative mx-auto max-w-[1600px] flex flex-row justify-center flex-wrap mobile:max-w-[150px] mobile:top-0 w-[90%]  [*&>:not(:last-child)]:mr-3 [*&>:not(:last-child)]:mobile:mr-0 [*&>:not(:last-child)]:mobile:mb-6">
            {learnMore.map((item) => (
              <li key={item.link}>
                <Link to={item.link}>
                  <span className="w-[250px] block table:w-[180px] mobile:w-full">
                    <img src={item.image} className="w-full" />
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
        <section className="bg-mission">
          <div className="w-[95%] max-w-[1200px] mx-auto py-32 flex flex-row justify-between table:py-24 mobile:max-w-[480px] mobile:flex-col mobile:w-[90%] mobile:py-10">
            <div className="w-[581px] mr-24 table:mr-14 table:w-[450px] mobile:w-full mobile:mb-8 mobile:mr-0">
              <img className="aspect-[581/402] w-full" src="./companyMission.png" alt="" />
            </div>
            <div className="flex-1">
              <div className="border-l-8 border-subTitle pl-3 mb-16 table:mb-10 mobile:mb-6 mobile:border-l-4">
                <h2 className="text-5xl text-title table:text-4xl mobile:text-3xl">企業使命</h2>
                <h3 className="text-2xl text-subTitle table:text-xl mobile:text-lg">Our Mission</h3>
              </div>
              <div>
                <p className="text-2xl font-zenOldMincho text-[#373737] table:text-xl mobile:text-base">
                  我們的使命是通過深入的市場洞察和專業知識，為客戶提供度身定制的資產管理解決方案。
                  <br />
                  我們追求長期價值創造，致力於保護和增值客戶的資產。透過卓越的客戶服務、創新的投資策略和堅持高標準的道德原則，我們助力客戶實現其財務目標，建立彼此信任的長期合作夥伴關係。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-[#f7f7f7]">
          <div className="w-[95%] max-w-[1200px] mx-auto py-32 flex flex-row justify-between table:py-24 mobile:max-w-[480px] mobile:flex-col-reverse mobile:w-[90%] mobile:py-10">
            <div className="flex-1">
              <div className="border-l-8 border-subTitle pl-3 mb-16 table:mb-10 mobile:mb-6 mobile:border-l-4">
                <h2 className="text-5xl text-title table:text-4xl mobile:text-3xl">未來願景</h2>
                <h3 className="text-2xl text-subTitle table:text-xl mobile:text-lg">
                  Future Vision
                </h3>
              </div>
              <div>
                <p className="text-2xl font-zenOldMincho text-[#373737] table:text-xl mobile:text-base">
                  我們致力於成為全球數一數二的資產管理權威，引領行業的創新潮流。透過整合科技和資訊分析，我們將提供更智能、精準的投資解決方案，以滿足客戶不斷演變的需求。我們的團隊將持續追求卓越，致力於社會責任，創建一個可持續發展的金融生態系統，為客戶和利益相關者實現共同繁榮。
                  <br />
                  我們致力於成為客戶資產增值的領先者，透過創新的投資策略和卓越的客戶服務，持續提供卓越的資產管理解決方案。公司追求在金融市場中的領導地位，並致力於為客戶創造可持續的財富增值，同時堅持高標準的道德和透明度。
                </p>
              </div>
            </div>
            <div className="w-[581px] ml-24 table:ml-14 table:w-[450px] mobile:w-full mobile:mb-8 mobile:ml-0">
              <img className="aspect-[581/402] w-full" src="./futureVision.jpeg" alt="" />
            </div>
          </div>
        </section>
        <section className="bg-news">
          <div className="w-[95%] max-w-[1200px] mx-auto py-32 flex flex-row justify-between table:py-24 mobile:max-w-[480px] mobile:flex-col mobile:w-[90%] mobile:py-10">
            <div className="w-[581px] mr-24 table:mr-14 table:w-[450px] mobile:w-full mobile:mb-8 mobile:mr-0">
              <img className="aspect-[581/402] w-full" src="./photo_03_1.jpg" alt="" />
            </div>
            <div className="flex-1">
              <div className="border-l-8 border-subTitle pl-3 mb-16 table:mb-10 mobile:mb-6 mobile:border-l-4">
                <h2 className="text-5xl text-title table:text-4xl mobile:text-3xl">企業永續</h2>
                <h3 className="text-2xl text-subTitle table:text-xl mobile:text-lg">
                  Future Vision
                </h3>
              </div>
              <div>
                <p className="text-2xl font-zenOldMincho text-[#373737] table:text-xl mobile:text-base">
                  我們會透過整合環境、社會和治理（ESG）因素，有助於客戶在投資組合中選擇更可持續的資產，同時考慮到財務回報和社會影響。
                  我們也提供ESG評估和報告，以協助客戶了解他們投資組合的永續性表現。
                  <br />
                  此外，鼓勵客戶參與社會責任投資，推動企業實踐社會和環境友好的經營模式。
                  <br />
                  總的來說，我們在促進企業永續方面發揮了促進和引導的作用，有助於形塑更加可持續的金融未來。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Home;
